
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from '../../../config';

export const useRemoveHospitalMutation = ({setModalOpen, setsnackbarStatus}) => {

  const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ updaterData }) => { // hospInfo: {Name: ..., _id: ...}

            return axios.post(`${config.API_URL}/operator/removeHospital`, updaterData, {
                withCredentials: true,
            });
        },
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({ queryKey: ['hospitalData'] , refetchType: 'active'}, {cancelRefetch: false});
            setModalOpen(false);
        },
        onError: (error, variables) => {
            setsnackbarStatus({ open: true, message: 'There was an error during the update', severity: 'error' });

        }
    });
}
